import { useTransferInvestorEntitySummaryTableDataRetrieveSuspense } from "gen/endpoints/investor-transfer/investor-transfer";
import { useTranslation } from "react-i18next";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";

export interface InvestorTransferReviewEntityTableProps {
  fundFamilyId: string;
  investorTransferId: string;
  isFullWidth?: boolean;
}

const InvestorTransferReviewEntityTable: React.FC<
  InvestorTransferReviewEntityTableProps & { isForTransferorEntity: boolean }
> = ({
  fundFamilyId,
  investorTransferId,
  isFullWidth,
  isForTransferorEntity,
}) => {
  const { t } = useTranslation(["commitment", "common", "investorTransfer"]);

  const { data: transferEntitySummaryTableData } =
    useTransferInvestorEntitySummaryTableDataRetrieveSuspense(
      fundFamilyId,
      investorTransferId,
      {
        is_for_transferor_entity: isForTransferorEntity,
      },
    );

  const title = isForTransferorEntity
    ? t("investorTransfer:setup.review.transferorTable.title")
    : t("investorTransfer:setup.review.transfereeTable.title");

  const emptyStateProps = isForTransferorEntity
    ? {
        title: t("investorTransfer:setup.review.transferorTable.empty.title"),
        description: t(
          "investorTransfer:setup.review.transferorTable.empty.description",
        ),
      }
    : {
        title: t("investorTransfer:setup.review.transfereeTable.empty.title"),
        description: t(
          "investorTransfer:setup.review.transfereeTable.empty.description",
        ),
      };

  return (
    <TableBox isFullWidth={isFullWidth}>
      <TableBoxHeader>
        <TableBoxTitle>{title}</TableBoxTitle>
        <DataTableBoxActions />
      </TableBoxHeader>
      <TableBoxBody>
        <DataTable
          data={transferEntitySummaryTableData}
          emptyStateProps={emptyStateProps}
        />
      </TableBoxBody>
    </TableBox>
  );
};

export const InvestorTransferReviewTransfereeEntitiesTable: React.FC<
  InvestorTransferReviewEntityTableProps
> = ({ fundFamilyId, investorTransferId, isFullWidth }) => (
  <InvestorTransferReviewEntityTable
    fundFamilyId={fundFamilyId}
    investorTransferId={investorTransferId}
    isFullWidth={isFullWidth}
    isForTransferorEntity={false}
  />
);

export const InvestorTransferReviewTransferorEntityTable: React.FC<
  InvestorTransferReviewEntityTableProps
> = ({ fundFamilyId, investorTransferId, isFullWidth }) => (
  <InvestorTransferReviewEntityTable
    fundFamilyId={fundFamilyId}
    investorTransferId={investorTransferId}
    isFullWidth={isFullWidth}
    isForTransferorEntity={true}
  />
);
